import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorPage } from '@im/ui-lib/ErrorPage';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useTranslate } from '@im/react-localization';
import ErrorBoundary, { ErrorBoundaryProps } from './ErrorBoundary';

export type PageErrorBoundaryProps = Pick<ErrorBoundaryProps, 'onReset'>;

const PageErrorBoundary: FC<PageErrorBoundaryProps> = ({
  children,
  onReset,
}) => {
  const translate = useTranslate();
  const navigate = useNavigate();
  const fallbackError = ({
    error,
    resetErrorBoundary,
  }: {
    error: Error;
    resetErrorBoundary: () => void;
  }): JSX.Element => (
    <>
      <ErrorPage
        data-testid="error"
        errorCode={(error as any).status}
        errorText={JSON.stringify(error, null, 4)}
        message={error.toString()}
      />
      <Stack flexDirection="row" gap={2} justifyContent="center">
        <Button
          onClick={resetErrorBoundary}
          size="large"
          variant="newContained"
        >
          {translate('Common.Discard')}
        </Button>
        <Button
          onClick={() => {
            resetErrorBoundary();
            navigate(-1);
          }}
          size="large"
          variant="newContained"
        >
          {translate('Common.BackToPrevious')}
        </Button>
      </Stack>
    </>
  );
  return (
    <ErrorBoundary fallback={fallbackError} onReset={onReset}>
      {children}
    </ErrorBoundary>
  );
};

export default PageErrorBoundary;
